module.exports = __webpack_public_path__ + "img/inside_float_layer.157e485.png";